import { Button, Input, message, Modal, Popconfirm, Radio, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { tokenVidsLabel } from "@extensions/enums";

const MessagesClients = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editPhone, setEditPhone] = useState("");

  const getData = () => {
    setLoading(true);
    const url = searchText ? `company/clients?searchText=${encodeURIComponent(searchText)}` : `company/clients`;
    serverFetch(url)
      .then(data => { setLoading(false); setItems(data); })
      .catch(e => { setLoading(false); message.error(e.userMessage); });
  };

  useEffect(getData, []);

  const handleEdit = () => {
    if (!selectedClientId) return message.warning("Выберите клиента для редактирования");
    const client = items.find(item => item.id === selectedClientId);
    if (client) { setEditPhone(client.phone); setEditModalVisible(true); }
  };

  const handleDelete = () => {
    setLoading(true);
    serverFetch(`company/Clients/${selectedClientId}`, { method: "DELETE" })
      .then(() => { message.success("Клиент удален"); setSelectedClientId(null); getData(); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка при удалении"); });
  };

  const handleSaveEdit = () => {
    setLoading(true);
    const client = items.find(item => item.id === selectedClientId);
    serverFetch(`company/Clients/${selectedClientId}`, { method: "PUT", bodyData: { ...client, phone: editPhone }})
      .then(() => { message.success("Телефон обновлен"); setEditModalVisible(false); getData(); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка при обновлении"); });
  };

  const columns = [
    { title: "", width: 50, render: (_, record) => <Radio checked={selectedClientId === record.id} onChange={() => setSelectedClientId(record.id)} /> },
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "companyId", title: "ID компании", width: 120 },
    { dataIndex: "phone", title: "Телефон", width: 150 },
    { dataIndex: "vid", title: "Вид", width: 120, render: tokenVidsLabel },
    { dataIndex: "messendgerId", title: "ID в мессенджере", width: 200 },
  ];

  return <>
    <Space style={{ marginBottom: 16 }}>
      <Input placeholder="Поиск клиентов..." value={searchText} onChange={e => setSearchText(e.target.value)} 
        onKeyPress={e => e.key === 'Enter' && getData()} style={{ width: 300 }} />
      <Button type="primary" onClick={getData} loading={loading}>Поиск</Button>
      <Button onClick={handleEdit} disabled={!selectedClientId || loading}>Редактировать</Button>
      <Popconfirm title="Подтверждение удаления" description="Вы уверены, что хотите удалить этого клиента?"
        onConfirm={handleDelete} okText="Удалить" cancelText="Отмена" disabled={!selectedClientId}>
        <Button danger disabled={!selectedClientId || loading}>Удалить</Button>
      </Popconfirm>
    </Space>
    
    <Table columns={columns} dataSource={items} loading={loading} rowKey="id" size="small" scroll={{ x: 'max-content' }} pagination={false} />

    <Modal title="Редактирование телефона клиента" open={editModalVisible} onOk={handleSaveEdit} 
      onCancel={() => { setEditModalVisible(false); setEditPhone(""); }} okText="Сохранить" cancelText="Отмена" confirmLoading={loading}>
      <div style={{ marginTop: 16 }}>
        <label>Телефон:</label>
        <Input value={editPhone} onChange={e => setEditPhone(e.target.value)} placeholder="Введите телефон" style={{ marginTop: 8 }} />
      </div>
    </Modal>
  </>;
};

export default MessagesClients;